// extracted by mini-css-extract-plugin
module.exports = {"customCursorCotainer":"ZoomableImage_customCursorCotainer__WcDZd","imageItemButton":"ZoomableImage_imageItemButton__HAbzY"};